var _title, _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOptimism = function SvgOptimism(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "\u5E01\u79CD\u5907\u4EFD 2")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 12,
    cy: 12,
    r: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u8865\\u5145\\u9700\\u6C42",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8FDE\\u63A5\\u94B1\\u5305-\\u624B\\u673A\\u5907\\u4EFD",
    transform: "translate(-223.000000, -266.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F39\\u7A97",
    transform: "translate(18.000000, 132.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-4",
    transform: "translate(20.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-2\\u5907\\u4EFD-2",
    transform: "translate(156.000000, 82.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(29.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u8499\\u7248"
  }), /*#__PURE__*/React.createElement("g", {
    id: "optimism.caeb9392",
    mask: "url(#mask-2)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#FF0420",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85495544,16 C7.01608475,16 6.32880363,15.7925669 5.7930557,15.37776 C5.2643519,14.9555511 5,14.3555763 5,13.5777763 C5,13.4148143 5.01763849,13.2147832 5.05285911,12.9777422 C5.14454543,12.4444444 5.27494626,11.8036699 5.44411795,11.0555371 C5.92345653,9.01851235 7.16063019,8 9.15558257,8 C9.69837462,8 10.1847573,8.09628495 10.614787,8.28885484 C11.0448167,8.47402275 11.3831601,8.75553483 11.6298735,9.13333185 C11.8765869,9.50366768 12,9.94814173 12,10.4666356 C12,10.6221956 11.9823615,10.8184961 11.9470845,11.0555371 C11.8413663,11.7147869 11.7144594,12.3555615 11.5664201,12.9777422 C11.3197066,13.9925832 10.8932272,14.7518486 10.2869817,15.2555385 C9.68073613,15.7518264 8.8700983,16 7.85495544,16 Z M8.00299476,14.3999882 C8.39780384,14.3999882 8.73259699,14.2777667 9.00754325,14.0333237 C9.28953364,13.7888807 9.49043207,13.4148143 9.61023853,12.9111244 C9.7723661,12.2148054 9.89577916,11.6073694 9.98036501,11.0888756 C10.0085415,10.9333156 10.0226298,10.7740842 10.0226298,10.611063 C10.0226298,9.93700916 9.68778026,9.59995263 9.01813761,9.59995263 C8.62332853,9.59995263 8.28498515,9.72217411 8.00299476,9.96661707 C7.72810485,10.2111193 7.53070031,10.5851857 7.41089384,11.0888756 C7.28398689,11.5851635 7.15707995,12.1925995 7.03022936,12.9111244 C7.00199651,13.0592232 6.98790826,13.2147832 6.98790826,13.3777452 C6.98790826,14.0592602 7.32630799,14.3999882 8.00299476,14.3999882 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2418282,16 C12.1556269,16 12.0889713,15.9733226 12.0419867,15.9199677 C12.0027701,15.8589994 11.9910553,15.7904787 12.0067168,15.7142835 L13.6288783,8.28571646 C13.6445399,8.20190792 13.6876405,8.13332623 13.7581802,8.07997137 C13.8287198,8.02667743 13.9031435,8 13.981514,8 L17.1083126,8 C17.9781556,8 18.675596,8.1752305 19.2006341,8.52569149 C19.7335656,8.87621339 20,9.38284087 20,10.0456958 C20,10.2361531 19.9765077,10.4342848 19.9294603,10.6399689 C19.7335656,11.5161823 19.3378293,12.1638104 18.7422516,12.5828531 C18.1545047,13.0018957 17.347308,13.2114171 16.3207242,13.2114171 L14.7338326,13.2114171 L14.1931329,15.7142835 C14.1774087,15.7980921 14.1343081,15.8666129 14.0638311,15.9199677 C13.9932915,15.9733226 13.9188051,16 13.8404973,16 L12.2418282,16 Z M16.4030414,11.6342817 C16.732122,11.6342817 17.0181647,11.546636 17.2611068,11.3714055 C17.5118797,11.196175 17.6764513,10.9447494 17.7548217,10.6171287 C17.7783141,10.4875787 17.7900916,10.3733165 17.7900916,10.2742811 C17.7900916,10.0533092 17.7234986,9.8856921 17.5902501,9.77142988 C17.4570016,9.64949333 17.2297837,9.58858596 16.9084712,9.58858596 L15.497866,9.58858596 L15.0511984,11.6342817 L16.4030414,11.6342817 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFFFFF"
  }))))))))));
};

export { SvgOptimism as ReactComponent };
export default __webpack_public_path__ + "78e2b1739c5109cd867bbc2f66a2a819.svg";